// extracted by mini-css-extract-plugin
module.exports = {"search":"topbar_search_2SBWR"};